/**
 * @description Creates a 3-stage progress bar to inform the user if they are starting, in comparison, or making the request.
 * The progress bar is displayed conditionally based on the user's location in the site. This is handled using react-router-dom.
 */
import React, { useState, useEffect } from "react";
import * as classNames from "@css/component/ProgressBar.module.scss";
import { useLocation } from "@reach/router";

const ProgressBar: React.FC = () => {
    const location = useLocation().pathname;
    const [currentStep, setCurrentStep] = useState<number | null>(null);

    const steps = [
        { label: "Stap 1: Starten", step: 1 },
        { label: "Stap 2: Vergelijken", step: 2 },
        { label: "Stap 3: Aanvragen", step: 3 },
    ];


    useEffect(() => {
        if (location.includes("/aanvragen")) {
            setCurrentStep(3);
        } else if (location === "/vergelijk") {
            setCurrentStep(2);
        } else {
            setCurrentStep(null); // Hide progress bar on non-relevant pages
        }
    }, [location]);

    if (currentStep === null) return null;
    return (
        <div className={classNames.progressBarWrapper}>
            <div className={classNames.progressBar}>
                {steps.map(({ label, step }, index) => {
                    const isCompleted = step < currentStep;
                    const isActive = step === currentStep;

                    return (
                        <div key={step} className={classNames.progressStep}>
                            <div
                                className={`${classNames.progressCircle} ${
                                    isCompleted ? classNames.completed : ""
                                } ${isActive ? classNames.active : ""}`}
                            >
                                <span className={`${classNames.progressIcon} ${isCompleted ? classNames.rotationForIcon : ""}`}>
                                    {isCompleted ? "L" : step}
                                </span>
                            </div>
                            <span
                                className={`${classNames.progressLabel} ${
                                    isActive
                                        ? classNames.activeLabel
                                        : isCompleted
                                            ? classNames.completedLabel
                                            : classNames.inactiveLabel
                                }`}
                            >
                                {label}
                            </span>
                            {index < steps.length - 1 && <div className={classNames.progressLine} />}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ProgressBar;
